module.exports = __webpack_public_path__ + "img/menu-prevention-active.7b784791.svg";